import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=6f3da1f5&scoped=true"
import script from "./signup.vue?vue&type=script&setup=true&lang=js"
export * from "./signup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./signup.vue?vue&type=style&index=0&id=6f3da1f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3da1f5",
  null
  
)

export default component.exports